var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 v-23.448H0V385.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v23.448h512v-23.448 C512,105.443,494.833,88.276,473.655,88.276z"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 150.07,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 211.86
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 141.24,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    y: 353.1,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 17.655
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M448.897,264.519H62.734c-2.621,0-4.745-2.124-4.745-4.745v-1.501c0-2.621,2.124-4.745,4.745-4.745 h386.163c2.621,0,4.745,2.124,4.745,4.745v1.501C453.642,262.394,451.518,264.519,448.897,264.519z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "373.962,242.538 393.195,234.295 412.428,242.538 393.195,250.781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M378.695,239.027H96.456c-1.939,0-3.511,1.571-3.511,3.511c0,1.939,1.571,3.511,3.511,3.511h282.238 c1.939,0,3.511-1.572,3.511-3.511S380.633,239.027,378.695,239.027z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "393.959,223.305 413.192,215.062 432.425,223.305 413.192,231.548 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M398.69,219.794H116.452c-1.939,0-3.511,1.571-3.511,3.511c0,1.939,1.571,3.511,3.511,3.511H398.69 c1.939,0,3.511-1.572,3.511-3.511S400.63,219.794,398.69,219.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M255.816,187.586c-48.808,0-91.39,27.639-114.197,68.69c22.806,41.05,65.389,68.69,114.197,68.69 s91.39-27.639,114.197-68.69C347.207,215.225,304.623,187.586,255.816,187.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M141.62,256.276c22.806,41.05,65.389,68.69,114.197,68.69c8.15,0,16.106-0.836,23.846-2.312 c-5.909-12.971-26.691-12.949-27.967-17.837c-1.374-5.266,16.943-4.121,20.149-8.472c3.206-4.35-17.401-6.182-18.317-10.532 c-0.916-4.351,8.243-7.327,9.846-14.196c1.603-6.869,5.266-8.929,8.013-13.05c2.748-4.121-4.579-5.495-6.411-19.233 s-12.594-15.57-17.859-26.788c-5.267-11.219,3.206-19.462,8.701-24.957C207.009,187.586,164.426,215.225,141.62,256.276z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184.37,
    y: 231.55,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.37,
    y: 231.55,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.36,
    y: 231.55,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.35,
    y: 231.55,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.34,
    y: 231.55,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.33,
    y: 231.55,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.37,
    y: 264.52,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.37,
    y: 264.52,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.36,
    y: 264.52,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.35,
    y: 264.52,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.34,
    y: 264.52,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.33,
    y: 264.52,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.495,
    height: 21.981
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 266.8,
    y: 231.55,
    style: {
      fill: "#464655"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.79,
    y: 231.55,
    style: {
      fill: "#464655"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.78,
    y: 231.55,
    style: {
      fill: "#464655"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.77,
    y: 231.55,
    style: {
      fill: "#464655"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.76,
    y: 231.55,
    style: {
      fill: "#464655"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.75,
    y: 231.55,
    style: {
      fill: "#464655"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.8,
    y: 264.52,
    style: {
      fill: "#464655"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.79,
    y: 264.52,
    style: {
      fill: "#464655"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.78,
    y: 264.52,
    style: {
      fill: "#464655"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.77,
    y: 264.52,
    style: {
      fill: "#464655"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.76,
    y: 264.52,
    style: {
      fill: "#464655"
    },
    width: 5.495,
    height: 21.981
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.75,
    y: 264.52,
    style: {
      fill: "#464655"
    },
    width: 5.495,
    height: 21.981
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#245DBD"
    },
    d: "M425.386,252.67c-4.401,10.223-16.925,11.426-9.985,37.486l3.554-3.608 c0,0,3.723,9.823,12.693,16.438c0,0,11-9.222,11.847-23.854l4.569,2.005C448.064,281.134,445.864,254.474,425.386,252.67z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M441.633,273.618c-0.352,0-0.701-0.163-0.966-0.482c-4.31-5.199-9.8-6.866-9.853-6.884 c-0.725-0.213-1.169-1.084-0.989-1.942c0.18-0.852,0.915-1.385,1.636-1.172c0.254,0.075,6.27,1.886,11.136,7.755 c0.524,0.627,0.515,1.647-0.015,2.268C442.318,273.468,441.977,273.618,441.633,273.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M438.531,285.746c-0.405,0-0.807-0.213-1.074-0.627c-3.197-4.924-6.823-7.605-6.86-7.63 c-0.638-0.463-0.833-1.453-0.441-2.211c0.394-0.751,1.227-0.983,1.865-0.52c0.167,0.119,4.088,3.026,7.584,8.407 c0.455,0.702,0.344,1.71-0.248,2.249C439.111,285.639,438.819,285.746,438.531,285.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M431.426,299.245c-0.076,0-0.153-0.007-0.233-0.025c-0.735-0.15-1.233-0.978-1.106-1.848 c0.534-3.671,0.087-9.691-0.646-12.798c-0.201-0.852,0.22-1.736,0.939-1.98c0.727-0.232,1.468,0.263,1.668,1.116 c0.828,3.508,1.312,10.055,0.708,14.201C432.644,298.694,432.071,299.245,431.426,299.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M421.903,284.436c-0.386,0-0.769-0.194-1.036-0.57c-0.481-0.676-0.409-1.692,0.161-2.261 c0.034-0.031,3.49-3.54,4.393-8.394c0.161-0.864,0.878-1.409,1.613-1.221c0.729,0.188,1.193,1.046,1.032,1.911 c-1.106,5.939-5.122,9.992-5.294,10.161C422.517,284.311,422.21,284.436,421.903,284.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M418.143,274.175c-0.455,0-0.899-0.269-1.155-0.765c-0.392-0.751-0.193-1.741,0.445-2.205 c0.051-0.038,4.961-3.652,6.484-7.598c0.309-0.814,1.119-1.172,1.795-0.796c0.68,0.37,0.979,1.322,0.669,2.124 c-1.869,4.842-7.302,8.833-7.531,9.002C418.626,274.1,418.383,274.175,418.143,274.175z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#245DBD"
    },
    d: "M82.285,256.11c-3.679,8.548-14.152,9.555-8.35,31.345l2.972-3.017c0,0,3.113,8.213,10.614,13.745 c0,0,9.198-7.711,9.906-19.947l3.821,1.676C101.248,279.913,99.409,257.62,82.285,256.11z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M95.871,273.628c-0.295,0-0.586-0.136-0.807-0.404c-3.604-4.348-8.194-5.741-8.239-5.757 c-0.606-0.178-0.978-0.906-0.826-1.624c0.15-0.713,0.765-1.158,1.368-0.98c0.212,0.063,5.242,1.577,9.311,6.485 c0.438,0.524,0.431,1.377-0.013,1.896C96.444,273.502,96.158,273.628,95.871,273.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M93.277,283.768c-0.339,0-0.674-0.178-0.898-0.524c-2.674-4.117-5.705-6.359-5.736-6.38 c-0.533-0.387-0.696-1.215-0.37-1.849c0.33-0.629,1.026-0.822,1.559-0.435c0.139,0.099,3.418,2.53,6.342,7.03 c0.381,0.587,0.288,1.43-0.207,1.88C93.761,283.679,93.517,283.768,93.277,283.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M87.335,295.057c-0.064,0-0.128-0.006-0.194-0.021c-0.615-0.126-1.031-0.818-0.925-1.545 c0.447-3.07,0.073-8.104-0.54-10.701c-0.168-0.713,0.183-1.451,0.785-1.655c0.608-0.194,1.227,0.22,1.395,0.932 c0.692,2.933,1.097,8.407,0.593,11.875C88.354,294.595,87.874,295.057,87.335,295.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M79.372,282.674c-0.323,0-0.643-0.162-0.867-0.477c-0.403-0.566-0.343-1.415,0.135-1.891 c0.029-0.026,2.919-2.959,3.672-7.019c0.135-0.723,0.734-1.178,1.348-1.022c0.61,0.157,0.998,0.875,0.863,1.598 c-0.925,4.966-4.284,8.355-4.427,8.497C79.885,282.569,79.629,282.674,79.372,282.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M76.228,274.093c-0.381,0-0.751-0.225-0.967-0.639c-0.328-0.629-0.161-1.457,0.372-1.844 c0.042-0.031,4.148-3.054,5.422-6.354c0.258-0.681,0.936-0.98,1.502-0.665c0.568,0.309,0.818,1.106,0.559,1.775 c-1.564,4.049-6.105,7.385-6.297,7.527C76.633,274.03,76.429,274.093,76.228,274.093z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSz);
export default __webpack_public_path__ + "static/media/sz.6f6eaabc88cc154bbb4cb4c39112f0d1.svg";
export { ForwardRef as ReactComponent };